module.exports = "https://static.wmbcdn.com/uniweb/images/67a4d0314fbf71cc73437f49d48f9cc0.svg";